import type { Product } from '@/models';

export { formatPrice } from '@/lib/utils';

export function resolvePrice(product: Pick<Product, 'price' | 'wholesalePrice'>): number {
  return product.wholesalePrice ?? product.price;
}
